<div class="spinner-container" *ngIf="isInitialLoadLoading">
    <mat-spinner class="content-box"></mat-spinner>
</div>

<mat-card appearance="outlined" class="mat-elevation-z8" [ngClass]="{'invisible': isInitialLoadLoading, 'visible': !isInitialLoadLoading }">
    <div class="container" *ngIf="certs">
        <div class="row">
            <mat-tab-group class="col" (selectedTabChange)="onTabChange($event)" animationDuration="0ms">
                <!-- Signing history -->
                <mat-tab>
                    <ng-template mat-tab-label class="mat-mdc-tab-label-container">
                        <cqes-icon icon="done"></cqes-icon>
                        {{'historyTexts.receivedHistory' | translate}}
                    </ng-template>
                    <mat-card >
                        <cloud-signing-history class="col-12" (isDataLoaded)="loadedData($event)"></cloud-signing-history>
                    </mat-card>
                </mat-tab>                
                <!-- Requested signing history -->
                <mat-tab>
                    <ng-template mat-tab-label>
                        <cqes-icon icon="done"></cqes-icon>
                        {{'historyTexts.sentHistory' | translate}}
                    </ng-template>
                    <mat-card *ngIf="requestTabSelected">
                        <cloud-requested-history class="col-12"></cloud-requested-history>
                    </mat-card>
                </mat-tab>

                <!-- Order history -->
                <mat-tab *ngIf="displayOrderHistoryTab()">
                        <ng-template mat-tab-label>
                            <cqes-icon icon="store"></cqes-icon>
                            {{'historyTexts.orderHistory' | translate}}
                        </ng-template>
                        <!-- TO DO : loading after clicking Orders tab-to be removed when using the new API -->
                        <mdc-card  *ngIf="ordersTabSelected">
                            <cloud-order-history class="col-12"></cloud-order-history>
                        </mdc-card>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</mat-card>